import React from 'react';

export const ShutterDecorativeFrame = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <path
          d="M41.4 46.7c.5-.2 19.4-11.9 19.4-11.9l30.1 22.9-9.5 30.4-40-39.1v-2.3zM41.4 49v39.6l40-.4z"
          fill="#bbbebf"
          stroke="#233762"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path fill="#ecf7f9" d="M47 29.1L2.8-4.7h-3.9l45.2 35.4z" />
        <path fill="#c8dfeb" d="M44.1 30.7L-1-4.7h-5.3l47.1 37.3z" />
        <g
          fill="#414142"
          stroke="#241f20"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M47 29.1c-.2.1-6.2 3.5-6.2 3.5L51 40.9l6.6-4.1L47 29.1z" />
          <path d="M40.8 32.6v14.8L51 40.9z" />
        </g>
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M41.4 30.6l-1.2 57.8h-8.5L-1.4 80V-1.7l23.9 18.9 1.1-.4z"
        />
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M30.5 36.4l1.2 52L-1.4 80V9.2M41.4 49v2.5l2.4 1.7-10.9 6.6.4 28.6h30.5l1.1-21z"
        />
        <path
          d="M32.9 59.8l5.4 4.7s2.1 2.5 4.4 1.2c2.3-1.3 6.2-4.1 6.2-4.1l9.6 6.6s-2.1 1.6-2.4 1.9c-1.7 1.4.7 1.8 1.9 1.2 2.2-1.4 7-4 7-4"
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.7 88.4V65.7s4.7 5.2 12.5 5.2M57.3 71.9l-.4 16.3M54.7 88.2l.4-17.2M38.3 64.5v23.9M-1.4 52.1l15.9 15.2M-1.4 69.1l13.1 14.3M15.4 84.3l-3-61.9M-1.4-1.7l23.9 18.9 1.1-.4 17.8 13.8-10.9 5.8-18.1-14 1.5-.7L-1.4 9.2z"
          fill="#fff"
          stroke="#233762"
          strokeWidth={0.772}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
